import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import BrandIntro from './components/BrandIntro';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import PhilosophySection from './components/PhilosophySection';
import NewsletterSection from './components/NewsletterSection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://caodenghoshang.com/#organization',
      name: '草灯和尚文化研究院',
      url: 'https://caodenghoshang.com/',
      description: '草灯和尚是承载禅宗智慧与草木灵性的文化符号，致力于传播东方生活美学与心灵修行之道。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'caodenghoshang@culture.org',
        contactType: 'customer service',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '杭州',
        addressRegion: '浙江',
        addressCountry: 'CN',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://caodenghoshang.com/#website',
      url: 'https://caodenghoshang.com/',
      name: '草灯和尚——禅意文化落地页',
      description: '草灯和尚，一位承载禅宗智慧与草木灵性的文化符号。探索草灯和尚背后的禅意故事、修行哲学与生活美学，感受以草为灯、以心照路的东方精神。',
      publisher: { '@id': 'https://caodenghoshang.com/#organization' },
      inLanguage: 'zh-Hans',
    },
    {
      '@type': 'WebPage',
      '@id': 'https://caodenghoshang.com/#webpage',
      url: 'https://caodenghoshang.com/',
      name: '草灯和尚——禅意文化落地页',
      isPartOf: { '@id': 'https://caodenghoshang.com/#website' },
      about: { '@id': 'https://caodenghoshang.com/#organization' },
      inLanguage: 'zh-Hans',
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <BrandIntro />
        <CategorySection />
        <FeaturedArticles />
        <PhilosophySection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}